export const enum PromotionSummaryId {
    ExistingJobs = 'Existing Jobs',
    NewJobs = 'New Jobs'
}

export const PromotionSummaryConverter: IPromotionSummaryConverter = {
    1: PromotionSummaryId.ExistingJobs,
    2: PromotionSummaryId.NewJobs
};

interface IPromotionSummaryConverter {
    [key: number]: PromotionSummaryId;
}

export enum PromotionSummaryIdNumber {
    ExistingJobs = 1,
    NewJobs = 2
}